export default function (e) {
  this.Parser = function (t) {
    return function (e, t) {
      if (void 0 === t && (t = {}), !e) return {
        type: "root",
        children: []
      };
      var n = e.split(/\n/g),
          o = {
        start: {
          column: 1,
          line: 1,
          offset: 0
        },
        end: {
          column: n[n.length - 1].length + 1,
          line: n.length,
          offset: e.length
        }
      },
          i = {
        type: "element",
        tagName: "code",
        position: o,
        children: [{
          type: "text",
          value: e,
          position: o
        }]
      },
          r = {
        type: "element",
        tagName: "pre",
        position: o,
        children: [i]
      },
          l = "language-" + (t.language || "txt");
      return i.properties = {
        className: [l]
      }, r.properties = {
        className: [l]
      }, {
        type: "root",
        children: [r],
        position: o
      };
    }(t, e);
  };
}